import { render, staticRenderFns } from "./BulkUntag.vue?vue&type=template&id=7df99474"
import script from "./BulkUntag.vue?vue&type=script&lang=js"
export * from "./BulkUntag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports